<template>
    <div class="password-strength-meter">
        <meter min="0" low="2" high="3" optimum="4" max="4" :value="score"></meter>

        <ul class="password-strength-meter__conditions list-reset">
            <li v-for="(conditionMet, conditionKey) in conditions" :class="conditionMet ? 'met' : 'not-met'">
                {{ __('passwords.strength_conditions.' + conditionKey) }}
            </li>
        </ul>
    </div>
</template>

<script>
import zxcvbn from "zxcvbn";

export default {
    props: {
        passwordFieldId: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            score: 0,
            conditions: {
                min: false,
                lowercase: false,
                uppercase: false,
                special: false,
                number: false
            }
        };
    },
    mounted() {
        let me = this;
        let passwordField = document.getElementById(this.passwordFieldId);

        passwordField.addEventListener('keyup', function() {
            let passwordTest = zxcvbn(this.value);
            let allConditionsMet = true;

            Object.keys(me.conditions).forEach((conditionKey) => {
                let conditionMet = false;

                switch(conditionKey) {
                    case 'min': conditionMet = this.value.length >= 8;
                        break;
                    case 'lowercase': conditionMet = /[a-zöäü]/.test(this.value);
                        break;
                    case 'uppercase': conditionMet = /[A-ZÖÄÜ]/.test(this.value);
                        break;
                    case 'special': conditionMet = /[^a-zöäü0-9]/i.test(this.value);
                        break;
                    case 'number': conditionMet = /[0-9]/.test(this.value);
                        break;
                }

                me.conditions[conditionKey] = conditionMet;
                allConditionsMet = allConditionsMet && conditionMet;
            });

            me.score = passwordTest.score;

            if(allConditionsMet || !this.value.length) {
                passwordField.classList.remove('is-invalid');
            } else {
                passwordField.classList.add('is-invalid');
            }
        });
    }
}
</script>

<style lang="scss">
    .password-strength-meter {
        meter {
            width: 100%;
            background: none;
            background-color: $bg-medium;
            box-shadow: none;

            &::-webkit-meter-bar {
                background: none;
                background: $bg-medium;
            }

            &::-webkit-meter-even-less-good-value {
                background: $state-relevant;
            }
            &::-webkit-meter-suboptimum-value {
                background: $state-warning;
            }
            &::-webkit-meter-optimum-value {
                background: $state-ok;
            }

            &:-moz-meter-sub-sub-optimum::-moz-meter-bar {
                background: $state-relevant;
            }
            &:-moz-meter-sub-optimum::-moz-meter-bar {
                background: $state-warning;
            }
            &:-moz-meter-optimum::-moz-meter-bar {
                background: $state-ok;
            }
        }

        &__conditions {
            margin-top: map-get($spacers, xs);
            font-size: map-get($font-sizes, sm);
            display: flex;
            flex-wrap: wrap;

            > li {
                flex: 0 0 auto;
                padding-right: map-get($spacers, md);

                &::before {
                    content: "";
                    display: inline-block;
                    height: 1em;
                    width: 1em;
                    background-image: url(/img/icons/cross.svg);
                    background-size: contain;
                    vertical-align: -2px;
                }

                &.met::before {
                    background-image: url(/img/icons/check-circle-green.svg);
                }
            }
        }
    }
</style>